import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { debounce } from "../../util";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  input: {
    backgroundColor: theme.palette.background.default,
  },
}));

const DebouncedField = ({
  id,
  name,
  label,
  value,
  delay = 500,
  component: Component = TextField,
  getValueFromChange,
  onDebouncedChange,
  ...props
}) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = React.useState(value || "");
  const isTextFieldComponent = Component === TextField;

  React.useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const debouncedChange = React.useMemo(
    () => debounce((nextValue) => onDebouncedChange(name, nextValue), delay),
    [delay, name, onDebouncedChange],
  );

  const handleValueChange = (nextValue) => {
    setInputValue(nextValue);
    debouncedChange(nextValue);
  };

  const handleChange = (eventOrValue) => {
    const nextValue = getValueFromChange ? getValueFromChange(eventOrValue) : eventOrValue?.target?.value ?? eventOrValue;
    handleValueChange(nextValue);
  };

  if (!isTextFieldComponent) {
    return (
      <Component
        {...props}
        id={id}
        name={name}
        label={label}
        value={inputValue}
        setValue={handleValueChange}
        onChange={handleChange}
        fullWidth
      />
    );
  }

  return (
    <TextField
      {...props}
      id={id}
      name={name}
      label={label}
      value={inputValue}
      onChange={handleChange}
      variant="outlined"
      size="small"
      InputLabelProps={{ shrink: true }}
      className={classes.root}
      InputProps={{
        className: classes.input,
      }}
      fullWidth
    />
  );
};

export default DebouncedField;
